export default __webpack_public_path__ + "static/media/5.71c5b7e1.jpg";